import { Button, Checkbox, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMenuItemEditor extends Layout {
    buttonLayoutSelector: Button;
    checkboxIdeOnly: Checkbox;
    checkboxLocalOnly: Checkbox;
    checkboxMcleodOnly: Checkbox;
    checkboxVisible: Checkbox;
    panelLeft: Panel;
    panelPath: Panel;
    panelRight: Panel;
    sourceWebMenuItem: DataSource;
    textboxCaption: Textbox;
    textboxClassName: Textbox;
    textboxCompanyType: Textbox;
    textboxFavoriteCaption: Textbox;
    textboxId: Textbox;
    textboxPath: Textbox;
}
